<template>
  <div id="project">
    <HeaderControlsProject :myWeek='false' @filterUpdated='false' @collapseToggleUpdated='false' />
    <div class="container-fluid">
      <ProjectList/>
    </div>
  </div>
</template>
<script>
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import ProjectList from "../components/deliverables/ProjectList";

export default {
  data() {
    return {}
  },
  components: {
    HeaderControlsProject,
    ProjectList
  }
};
</script>